<template>
  <a-row :gutter="24">
    <a-col :md="24">
      <a-card :style="cardStyle" :bordered="false">
        <div class="table-page-search-wrapper">
          <a-form layout="inline" @keyup.enter.native="searchQuery">
            <a-row :gutter="24">
              <a-col :md="5" :sm="24">
                <a-form-item label="客户形态" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-select v-model="queryParam.customerType" placeholder="全部形态" allowClear style="width: 100%" @change="searchQuery">
                    <a-select-option v-for="t in typeOptions" :key="t.value" :value="t.value">{{ t.label }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="客户名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input placeholder="请输入客户名称查询" v-model="queryParam.search"></a-input>
                </a-form-item>
              </a-col>
              <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                <a-col :md="10" :sm="24">
                  <a-button type="primary" @click="searchQuery">查询</a-button>
                  <a-button style="margin-left: 8px" @click="searchReset">重置</a-button>
                </a-col>
              </span>
            </a-row>
          </a-form>
        </div>
        <div class="table-operator" style="margin-bottom: 16px">
          <a-button v-if="btnEnableList.indexOf(1)>-1" type="primary" icon="plus" @click="handleAdd">新增客户信用</a-button>
          <span style="margin-left: 8px; color: #999">信用体系为提示性管控：客户下单/生成订单时返回信用提示，不拦截业务。</span>
        </div>
        <section>
          <a-table
            ref="table"
            size="middle"
            bordered
            rowKey="id"
            :columns="columns"
            :dataSource="dataSource"
            :pagination="false"
            :scroll="scroll"
            :loading="loading"
            @change="handleTableChange">
            <template slot="settle" slot-scope="text, record">
              <a-tag color="blue">{{ record.settleTypeName }}</a-tag>
              <span v-if="Number(record.creditLimit) > 0" style="margin-left: 4px">额度 {{ record.creditLimit }}</span>
            </template>
            <template slot="debt" slot-scope="text, record">
              <span :style="Number(record.debt) > 0 ? 'color: #f5222d' : ''">{{ record.debt }}</span>
            </template>
            <span slot="action" slot-scope="text, record">
              <template v-if="btnEnableList.indexOf(1)>-1">
                <a @click="handleEdit(record)">编辑</a>
                <a-popconfirm title="确定删除该客户的信用配置吗?" @confirm="() => handleDelete(record)">
                  <a style="margin-left: 8px">删除</a>
                </a-popconfirm>
              </template>
              <span v-else>-</span>
            </span>
          </a-table>
        </section>
        <a-pagination
          style="margin-top: 16px; text-align: right"
          :current="ipagination.current"
          :pageSize="ipagination.pageSize"
          :total="ipagination.total"
          @change="paginationChange"
          @showSizeChange="paginationShowSizeChange"
        />
        <!-- 新增/编辑弹窗：结算方式联动 holdN/settleDays 显隐 -->
        <a-modal
          :title="modalTitle"
          :visible="modalVisible"
          :confirmLoading="modalLoading"
          :maskClosable="false"
          @ok="handleOk"
          @cancel="modalVisible = false">
          <a-form-item label="客户形态" :labelCol="{ span: 6 }" :wrapperCol="{ span: 15 }">
            <a-select v-model="form.customerType" style="width: 100%" @change="onTypeChange">
              <a-select-option v-for="t in typeOptions" :key="t.value" :value="t.value">{{ t.label }}</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="客户" :labelCol="{ span: 6 }" :wrapperCol="{ span: 15 }">
            <a-select
              v-model="form.customerRef"
              showSearch
              optionFilterProp="children"
              placeholder="请选择客户"
              style="width: 100%">
              <a-select-option v-for="c in customerOptions" :key="c.id" :value="c.id">{{ c.name }}</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="结算方式" :labelCol="{ span: 6 }" :wrapperCol="{ span: 15 }">
            <a-select v-model="form.settleType" style="width: 100%">
              <a-select-option v-for="s in settleOptions" :key="s.value" :value="s.value">{{ s.label }}</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item v-if="form.settleType === 'HOLD_N'" label="压单数N" :labelCol="{ span: 6 }" :wrapperCol="{ span: 15 }">
            <a-input-number v-model="form.holdN" :min="1" :max="99" style="width: 100%" placeholder="手里保留N单货款，第N+1单结第1单" />
          </a-form-item>
          <a-form-item v-if="form.settleType === 'MONTHLY'" label="对账日" :labelCol="{ span: 6 }" :wrapperCol="{ span: 15 }">
            <a-input-number v-model="form.settleDays" :min="1" :max="31" style="width: 100%" placeholder="每月几号对账回款（1-31）" />
          </a-form-item>
          <a-form-item label="授信额度" :labelCol="{ span: 6 }" :wrapperCol="{ span: 15 }">
            <a-input-number v-model="form.creditLimit" :min="0" :precision="2" style="width: 100%" placeholder="0=不启用额度管控；欠款超额度时提示" />
          </a-form-item>
          <a-form-item label="备注" :labelCol="{ span: 6 }" :wrapperCol="{ span: 15 }">
            <a-textarea v-model="form.remark" :rows="2" placeholder="合同约定等备注信息" />
          </a-form-item>
        </a-modal>
      </a-card>
    </a-col>
  </a-row>
</template>
<script>
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { getCustomerCredits, getCustomerCreditOptions, saveCustomerCredit, deleteCustomerCredit } from '@/api/plugin/orderReceive'

export default {
  name: 'CustomerCreditList',
  mixins: [JeecgListMixin],
  data() {
    return {
      labelCol: { span: 7 },
      wrapperCol: { span: 16, offset: 1 },
      urlPath: '/plugin/order-receive/customer-credit',
      scroll: { x: 1150 },
      queryParam: {
        customerType: undefined,
        search: ''
      },
      columns: [
        {
          title: '序号',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function(t, r, index) {
            return parseInt(index) + 1
          }
        },
        { title: '客户名称', dataIndex: 'customerName', width: 200 },
        { title: '客户形态', dataIndex: 'customerTypeName', width: 100, align: 'center' },
        {
          title: '结算方式',
          key: 'settle',
          width: 200,
          scopedSlots: { customRender: 'settle' }
        },
        {
          title: '实时欠款',
          key: 'debt',
          width: 120,
          align: 'right',
          scopedSlots: { customRender: 'debt' }
        },
        { title: '提示预览', dataIndex: 'tipPreview', ellipsis: true },
        { title: '备注', dataIndex: 'remark', width: 140, ellipsis: true },
        {
          title: '操作',
          dataIndex: 'action',
          width: 120,
          align: 'center',
          scopedSlots: { customRender: 'action' }
        }
      ],
      url: {
        list: '/api/plugin/order-receive/customer-credits'
      },
      typeOptions: [
        { value: 'archive', label: '客户档案' },
        { value: 'partner', label: 'B2B租户' },
        { value: 'h5', label: '微信客户' }
      ],
      settleOptions: [
        { value: 'CASH', label: '现结（现款现货）' },
        { value: 'HOLD_N', label: '压N单（滚动结算）' },
        { value: 'MONTHLY', label: '月结（账期结算）' },
        { value: 'WEEKLY', label: '周结' },
        { value: 'TEN_DAY', label: '旬结' },
        { value: 'PER_BILL', label: '单单结（一票一结）' },
        { value: 'PREPAY', label: '预付款（先款后货）' },
        { value: 'COD', label: '货到付款' },
        { value: 'NONE', label: '无约定' }
      ],
      customerOptions: [],
      modalTitle: '新增客户信用',
      modalVisible: false,
      modalLoading: false,
      form: {}
    }
  },
  methods: {
    getQueryParams() {
      return {
        currentPage: this.ipagination.current,
        pageSize: this.ipagination.pageSize,
        customerType: this.queryParam.customerType || undefined,
        search: this.queryParam.search || undefined
      }
    },
    /** 形态切换：重载对应下拉数据源并清空已选客户 */
    onTypeChange() {
      this.form.customerRef = undefined
      this.loadCustomerOptions(this.form.customerType)
    },
    /** ensure：编辑回显时当前客户不在下拉列表则补入，避免回显空白 */
    loadCustomerOptions(type, ensure) {
      if (!type) {
        this.customerOptions = []
        return
      }
      getCustomerCreditOptions(type).then((res) => {
        if (res.code === 200) {
          const options = res.data || []
          if (ensure && ensure.customerRef && !options.some((c) => c.id === ensure.customerRef)) {
            options.unshift({ id: ensure.customerRef, name: ensure.customerName })
          }
          this.customerOptions = options
        }
      })
    },
    handleAdd() {
      this.modalTitle = '新增客户信用'
      this.form = { customerType: 'archive', customerRef: undefined, settleType: 'MONTHLY', holdN: 1, settleDays: undefined, creditLimit: 0, remark: '' }
      this.loadCustomerOptions('archive')
      this.modalVisible = true
    },
    handleEdit(record) {
      this.modalTitle = '编辑客户信用 - ' + record.customerName
      this.form = {
        customerType: record.customerType,
        customerRef: record.customerRef,
        settleType: record.settleType,
        holdN: record.holdN == null ? 1 : Number(record.holdN),
        settleDays: record.settleDays == null ? undefined : Number(record.settleDays),
        creditLimit: record.creditLimit == null ? 0 : Number(record.creditLimit),
        remark: record.remark || ''
      }
      this.loadCustomerOptions(record.customerType, { customerRef: record.customerRef, customerName: record.customerName })
      this.modalVisible = true
    },
    handleOk() {
      if (!this.form.customerType) {
        this.$message.warning('请选择客户形态')
        return
      }
      if (!this.form.customerRef) {
        this.$message.warning('请选择客户')
        return
      }
      if (!this.form.settleType) {
        this.$message.warning('请选择结算方式')
        return
      }
      this.modalLoading = true
      saveCustomerCredit({
        customerType: this.form.customerType,
        customerRef: this.form.customerRef,
        settleType: this.form.settleType,
        holdN: this.form.holdN,
        settleDays: this.form.settleDays,
        creditLimit: this.form.creditLimit,
        remark: this.form.remark
      }).then((res) => {
        if (res.code === 200) {
          this.$message.success('保存成功')
          this.modalVisible = false
          this.loadData()
        } else {
          this.$message.warning(res.message || '保存失败')
        }
      }).catch((err) => {
        this.$message.warning((err && err.message) || '保存失败')
      }).finally(() => {
        this.modalLoading = false
      })
    },
    handleDelete(record) {
      deleteCustomerCredit(record.id).then((res) => {
        if (res.code === 200) {
          this.$message.success(res.message || '删除成功')
          this.loadData()
        } else {
          this.$message.warning(res.message || '删除失败')
        }
      })
    },
    searchReset() {
      this.queryParam = { customerType: undefined, search: '' }
      this.loadData(1)
    },
    paginationChange(current, pageSize) {
      this.ipagination.current = current
      this.ipagination.pageSize = pageSize
      this.loadData()
    },
    paginationShowSizeChange(current, pageSize) {
      this.ipagination.current = 1
      this.ipagination.pageSize = pageSize
      this.loadData()
    }
  }
}
</script>
<style scoped>
.table-page-search-wrapper { margin-bottom: 15px; }
</style>
